export const comments_3296368 = {"data":{"data":[],"links":{}}}